export default "__VITE_ASSET__CmSVwgCB__"